module.exports = __webpack_public_path__ + "static/media/emot2_off.810ce9fe.svg";